import { useTheme } from "src/lib/theme/ThemeProvider";

export function Visa({ className }) {
  const { theme } = useTheme();

  return (
    <svg
      enableBackground="new 0 0 3384.54 2077.85"
      version="1.1"
      viewBox="0 0 3384.5 2077.8"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fill={theme === "dark" ? "#FFFFFF" : "#1434CB"}
        d="m1461.3 739.84-251.37 599.74h-164l-123.7-478.62c-7.51-29.48-14.04-40.28-36.88-52.7-37.29-20.23-98.87-39.21-153.05-50.99l3.68-17.43h263.99c33.65 0 63.9 22.4 71.54 61.15l65.33 347.04 161.46-408.2h163zm642.58 403.93c0.66-158.29-218.88-167.01-217.37-237.72 0.47-21.52 20.96-44.4 65.81-50.24 22.23-2.91 83.48-5.13 152.95 26.84l27.25-127.18c-37.33-13.55-85.36-26.59-145.12-26.59-153.35 0-261.27 81.52-262.18 198.25-0.99 86.34 77.03 134.52 135.81 163.21 60.47 29.38 80.76 48.26 80.53 74.54-0.43 40.23-48.23 57.99-92.9 58.69-77.98 1.2-123.23-21.1-159.3-37.87l-28.12 131.39c36.25 16.63 103.16 31.14 172.53 31.87 162.99 0 269.61-80.51 270.11-205.19m404.94 195.81h143.49l-125.25-599.74h-132.44c-29.78 0-54.9 17.34-66.02 44l-232.81 555.74h162.91l32.34-89.58h199.05l18.73 89.58zm-173.11-212.5 81.66-225.18 47 225.18h-128.66zm-652.74-387.24-128.29 599.74h-155.14l128.34-599.74h155.09z"
      />
    </svg>
  );
}
